<!-- <body> -->
    <div class="content">
        <div class="container-fluid">
            <div class="content box_shadow table_container">
                <span class="graphtitledata">Grievance Report Details</span>
                <hr>
                <button (click)="onBtExport()"
                    style="margin-bottom: 5px; font-weight: bold;margin-left: 20px; margin-top: 5px; position: absolute;">
                    Download Excel</button>
                <input type="text " class="input " (input)="onQuickFilterChanged($event)" placeholder="Search..." />
                <ag-grid-angular  class="table_list"
                    [rowData]="rowData" [pinnedTopRowData]="pinnedTopRowData" [columnDefs]="colDefs"
                    [defaultColDef]="defaultColDef" [quickFilterText]="quickFilter"  [defaultExcelExportParams]="defaultExcelExportParams" (gridReady)="onGridReady($event)"/>
            </div>
        </div>
    </div>
<!-- </body> -->